// extracted by mini-css-extract-plugin
module.exports = {"verified":"Verified__verified__fd02G","verifiedIcon":"Verified__verifiedIcon__g4Xhb"};